import { render, staticRenderFns } from "./login.vue?vue&type=template&id=710e2d4e&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=710e2d4e&prod&lang=css"
import style1 from "./login.vue?vue&type=style&index=1&id=710e2d4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e2d4e",
  null
  
)

export default component.exports